import './style.css';
import { initFirebase, getFirebase } from './firebase.js';
import { createShellViews } from './core/ui/shellViews.js';
import { createFirebaseDiagScreen } from './core/app/firebaseDiagScreen.js';
import { bootstrapMlvApp } from './core/app/bootstrapMlvApp.js';
import { initMlvTelemetry } from './core/telemetry/mlvTelemetryBootstrap.js';

const appEl = document.getElementById('app');

function render(html) {
  appEl.innerHTML = html;
}

const shell = createShellViews({
  render,
  getLoginView: () => () => {},
});

const showFirebaseDiagView = createFirebaseDiagScreen({
  render,
  loadingView: shell.loadingView,
  getFirebase,
});

let firebaseInit;
try {
  firebaseInit = initFirebase();
} catch (err) {
  console.error(err);
  shell.renderInitFirebaseError(err);
  firebaseInit = { ok: false };
}

if (!firebaseInit?.ok) {
  if (firebaseInit?.missing?.length) shell.missingEnvView(firebaseInit.missing);
} else {
  initMlvTelemetry();
  if (new URLSearchParams(location.search).get('fbdiag') === '1') {
    showFirebaseDiagView().catch((err) => {
      console.error(err);
      shell.errorView('No se pudo ejecutar el diagnóstico', err);
    });
  } else {
    bootstrapMlvApp({ appEl, getFirebase });
  }
}
